import styles from './compact-disclaimer.module.css';
import { FormattedMessage } from 'react-intl';
import { useAtomValue } from 'jotai/index';
import { selectedPlanAtom } from '@features/Stripe/atoms';
import classNames from 'classnames';

type TpCompactDisclaimerProps = {
  price?: string;
  billingPeriod?: number;
  billingPeriodUnit?: string;
  theme?: 'light' | 'dark';
};

export const CompactDisclaimer = ({
  price,
  billingPeriod,
  billingPeriodUnit,
  theme,
}: TpCompactDisclaimerProps) => {
  const plan = useAtomValue(selectedPlanAtom);

  return (
    <div
      className={classNames(
        styles.container,
        theme === 'dark' && styles.darkThemed,
      )}
    >
      <FormattedMessage
        id="Paywall.CompactDisclaimer"
        values={{
          price: price || plan.fullPriceDiscount,
          billingPeriod: billingPeriod || plan.billingPeriod,
          billingPeriodUnit: billingPeriodUnit || plan.billingPeriodUnit,
        }}
      />
    </div>
  );
};
